import React from "react";
import RightHandSide from "../../Common/Services/RightHandSide";
import AboutInnBanContent from "../../Common/InnerBanner/AboutInnBanContent";
import { AboutInnerBanner } from "../../Common/InnerBanner/AboutInnerBanner";
import HeadContent from "../BlogContent/HeadContent";
import HeadDesign from "../BlogContent/HeadDesign";
import Info from "../BlogContent/Info";
import List from "../BlogContent/List";
import InfoContent from "../BlogContent/InfoContent";
import ListContent from "../BlogContent/ListContent";
import RecentBlogsList from "../BlogContent/RecentBlogsList";
import { Helmet } from "react-helmet";

const Blog28 = () => {
  const { image, heading, pageName } = AboutInnBanContent.BlogDetails;
  const { bg, para, date, blogHeading } = HeadContent.blog_28;

  const { title, p } = InfoContent.Blog_28.one;
  const { title2, p2 } = InfoContent.Blog_28.two;
  const { title3, p3, p3b } = InfoContent.Blog_28.three;
  const { title4, p4 } = InfoContent.Blog_28.four;
  const { title5, p5, p5a, p5b, p5c } = InfoContent.Blog_28.five;
  const { title6, p6, p6b } = InfoContent.Blog_28.six;
  const { Ctitle, Cp } = InfoContent.Blog_28.conclusion;
  const { title7, p7 } = InfoContent.Blog_28.seven;
  const { title8, p8 } = InfoContent.Blog_28.eight;

  const { liss1 } = ListContent.Blog_28.L1;
  const { liss5a } = ListContent.Blog_28.L5a;
  const { liss5b } = ListContent.Blog_28.L5b;
  const { liss6 } = ListContent.Blog_28.L6;
  const { liss8 } = ListContent.Blog_28.L8;
  return (
    <>
      <Helmet>
        <title>
          IVF Success Rates in India: Proven 2026 Guide
        </title>

        <meta
          name="description"
          content="IVF Success Rates in India explained by age, clinic quality, and donor egg IVF. Learn what improves outcomes and visit Acme Fertility for expert care."
        />

        <meta
          name="keywords"
          content="IVF Success Rates in India, ivf success rate in india, donor egg ivf success rates in india,highest success rate of ivf in india,IVF success by age in India,best IVF centre in Mumbai,IVF treatment success factors,donor egg IVF success India,IVF clinic with high success rate,fertility treatment in Mumbai" />

        <link
          rel="canonical"
          href="https://www.acmefertility.com/20/BlogDetails"
        />

        {/* Article Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline:
              "7 Proven IVF Success Rates in India: What Couples Should Know in 2026",
            description:
              "Understand IVF Success Rates in India, donor egg IVF outcomes, and the factors that influence successful pregnancy and live birth rates.",
            author: {
              "@type": "Organization",
              name: "Acme Fertility",
            },
            publisher: {
              "@type": "Organization",
              name: "Acme Fertility",
            },
            datePublished: "2026-07-17",
            dateModified: "2026-07-17",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": "https://www.acmefertility.com/",
            },
          })}
        </script>

        {/* Author Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Acme Fertility",
            description:
              "Trusted fertility centre in Mumbai with 20+ years of experience in IVF, ICSI, donor egg IVF, and advanced reproductive care.",
            url: "https://www.acmefertility.com/",
          })}
        </script>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the average IVF success rate in India?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "The average IVF success rate in India is 35–55% per cycle, depending on the woman’s age, embryo quality, and the expertise of the fertility centre.",
                },
              },
              {
                "@type": "Question",
                name: "What are donor egg IVF success rates in India?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Donor egg IVF success rates in India are usually 60–70% because the eggs come from younger donors with better ovarian reserve and lower chromosomal abnormality rates.",
                },
              },
              {
                "@type": "Question",
                name: "Which age group has the highest IVF success rate?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Women under 30 generally have the highest IVF success rates, often between 50% and 60% per treatment cycle.",
                },
              },
              {
                "@type": "Question",
                name: "Can IVF be successful after age 40?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, IVF can be successful after 40, but the chances are lower with own eggs. Donor egg IVF significantly improves success rates in this age group.",
                },
              },
              {
                "@type": "Question",
                name: "How can I improve my IVF success rate?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can improve IVF success by maintaining a healthy weight, avoiding smoking, controlling medical conditions, taking folic acid, and following a personalized fertility treatment plan.",
                },
              },
            ],
          })}
        </script>
      </Helmet>

      <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

      <div className="blog-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <HeadDesign
                bg={bg}
                para={para}
                date={date}
                blogHeading={blogHeading}
              />
              <Info title={title} p={p} />
              <Info title={title2} p={p2} />
              <Info title={title3} p={p3} />
              <List liss={liss1} />
              <Info p={p3b} />
              <Info title={title4} p={p4} />
              <Info title={title5} p={p5} />
              <Info p={p5a} />
              <List liss={liss5a} />
              <Info p={p5b} />
              <List liss={liss5b} />
              <Info p={p5c} />
              <Info title={title6} p={p6} />
              <List liss={liss6} />
              <Info p={p6b} />
              <Info title={Ctitle} p={Cp} />
              <Info title={title7} p={p7} />
              <Info title={title8} p={p8} />
              <List liss={liss8} />
            </div>

            <div className="col-lg-4">
              <RecentBlogsList />
              <RightHandSide />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog28;
